import CryptoJS from 'crypto-js';

export class FrontendEncryption {
  constructor(secretKey) {
    this.secretKey = secretKey;
  }

  encrypt(data) {
    console.log("encrypted data", data)
    try {
      if (typeof data === 'object') {
        data = JSON.stringify(data);
      }
      const encrypted = CryptoJS.AES.encrypt(data, this.secretKey).toString();
      return encrypted;
    } catch (error) {
      console.error('Encryption error:', error);
      throw new Error('Failed to encrypt data');
    }
  }

  decrypt(encryptedData) {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      
      try {
        return JSON.parse(decrypted);
      } catch {
        return decrypted;
      }
    } catch (error) {
      console.error('Decryption error:', error);
      throw new Error('Failed to decrypt data');
    }
  }

  createEncryptedPayload(data) {
    const timestamp = Date.now();
    const payload = {
      data: data,
      timestamp: timestamp,
      nonce: Math.random().toString(36).substring(2, 15)
    };
    
    return this.encrypt(payload);
  }

  extractFromEncryptedResponse(encryptedResponse) {
    const decrypted = this.decrypt(encryptedResponse);
    return decrypted.data || decrypted;
  }
}